// extracted by mini-css-extract-plugin
module.exports = {"cardcontainer":"cardsContainer_cardcontainer__3aLXx","link":"cardsContainer_link__SicJ3","container":"cardsContainer_container__2N5Jt"};